import { useUser } from "contexts/UserContext";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const { setUser } = useUser();

  return (
    <div className="header header-grid row-flex">
      <nav className="navbar row-flex">
        <Link className="m-l-3" to="/">
          <h3 className="logo">
            neha<span className="text-shd"> gupta</span>
          </h3>
        </Link>
        <ul className="nav-items row-flex no-bullet">
          <li className="btn nav-link-btn h3 m-v-2 m-r-3">
            <Link to="/">About</Link>
          </li>
          <li className="btn nav-link-btn h3 m-v-2 m-r-3">
            <a href="#project">Projects</a>
          </li>
          <li className="btn nav-link-btn h3 m-v-2 m-r-3">
            <a href="#connect">Connect</a>
          </li>
        </ul>

        <ul className="row-flex no-bullet">
          <li
            className="dark-mode icon-toggle icon-btn rd-bdr grid-ctr colored-text m-r-3"
            onClick={() => {
              setUser((prev) => ({ ...prev, isDark: !prev.isDark }));
            }}
          ></li>
        </ul>
      </nav>
    </div>
  );
};
